export class SearchTourModel {
  cityCode: string;
  countryCode: string;
  city: string;
  checkIn?: Date;
  roomType: string;
  flightSourcesDefault: string;

  constructor(params?: URLSearchParams) {
    if (params) {
      const paramsObj = Object.fromEntries(params.entries());
      this.cityCode = paramsObj.cityCode;
      this.countryCode = paramsObj.countryCode;
      this.checkIn = new Date(paramsObj.checkIn);
      this.roomType = paramsObj.roomType;
      this.city = paramsObj.city;
      this.flightSourcesDefault = paramsObj.flightSourcesDefault;
    } else {
      this.cityCode = '';
      this.countryCode = '';
      this.roomType = '';
      this.city = '';
      this.flightSourcesDefault = 'ALP';
    }
  }
}
